import React, { memo } from "react";
import { useIntl } from "react-intl";
import { MapContainer, TileLayer, GeoJSON, Polygon } from "react-leaflet";
import "react-leaflet-fullscreen/dist";
import "react-leaflet-fullscreen/dist/styles.css";
import MapCache from "../MapCache";
import OverlayGeoJSON from "~/components/OverlapPlots/OverlayGeoJSON";
import "./style.scss";
import mapHelpers from '~/utils/mapHelpers';

const OVERLAY_COLOR = "#fb8c00";

const AreaMap = memo(({ aoiInfo, layers, overlayGeoms = [], showLegend = false, ...props }) => {
  const { formatMessage } = useIntl();

  const geojson = aoiInfo.B3Area.geojson_simplificado;
  let coordinates = geojson.coordinates;

  const isMultiPolygon = geojson.type === 'MultiPolygon';

  const centroid = aoiInfo.B3Area.geojson_centroid;

  const onlyXY = mapHelpers.getOnlyXY(coordinates, { isMultiPolygon });
  const bounds = mapHelpers.reverseCoordinates(onlyXY, { isMultiPolygon });

  coordinates = bounds;

  return (
    <>
      <MapContainer
        fullscreenControl
        center={centroid.coordinates.reverse()}
        bounds={bounds}
        maxBounds={bounds}
        {...props}
      >
        <TileLayer
          url="http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}"
          minZoom="10"
          subdomains={["mt0", "mt1", "mt2", "mt3"]}
        />

        <MapCache />

        <Polygon color="#13FFE8" positions={coordinates} />

        {overlayGeoms.map((detalhe, index) => (
          <OverlayGeoJSON
            key={`overlay-gleba-${index}`}
            geom={detalhe.geom}
            detalhe={detalhe}
          />
        ))}

        {layers &&
          layers.map(layer =>
            layer.layer.features.map((feature, index) => (
              <GeoJSON
                key={`${layer.slug}-${index}`}
                data={feature.geometry}
                {...layer.style}
              />
            ))
          )}
      </MapContainer>

      {showLegend && (
        <div className="area-map-legend">
          <p className="title">{formatMessage({ id: "legenda" })}</p>
          <p>
            <span
              className="legend-color"
              style={{ backgroundColor: "#13FFE8" }}
            />
            {formatMessage({ id: "area-consultada" })}
          </p>
          {layers &&
            layers.map(layer => (
              <p key={layer.slug}>
                <span
                  className="legend-color"
                  style={{ backgroundColor: layer.style && layer.style.color }}
                />
                {layer.name}
              </p>
            ))}
        </div>
      )}
    </>
  );
});

export default AreaMap;
